import Collapse from "./Collapse";
import PlainCollapse from "./PlainCollapse";

export { PlainCollapse };
export default Collapse;
